import { getReports } from "../../apis";
import { getUserList } from "../../apis/apiUsers";

import { setCurrentReport, setCurrentReportInvestigation, setReports } from "./jaguarSlice";
import { formatInvestigationInvolveds, formatInvestigationResources, formatReportRelativeFields, formatReportUsers } from "./jaguarHelpers";

export const startGettingReports = () => async (dispatch) => {
  const reports = await getReports();
  if (!reports) return;
  dispatch(setReports(reports));
};

export const startSettingDetailReport = (reportDetail, usersAssigned) => async (dispatch) => {
  // const resp = await getUserList();
  // const { usersInfo, meInfo } = formatReportUsers(resp?.users || []);
  const { usersInfo, meInfo } = formatReportUsers(usersAssigned?.users || []);
  const relativeFields = formatReportRelativeFields(reportDetail);
  dispatch(setCurrentReport({
    reportDetail, 
    users: usersInfo,
    me: meInfo,
    relativeFields: relativeFields || {}
  }));
};

export const startSettingInvestigation = (investigation) => async (dispatch) => {
  
  const involveds = formatInvestigationInvolveds(investigation);
  const humanResources = formatInvestigationResources(investigation);

  dispatch(setCurrentReportInvestigation({
    id: investigation.alias,
    name: investigation.title,
    ...involveds,
    ...humanResources,
  }));
};
